import TiltedMenu from './TiltedMenu';

export default TiltedMenu;
